'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _promise = require('promise');

var _promise2 = _interopRequireDefault(_promise);

var _ProjectShareRenderer = require('./ProjectShareRenderer');

var _ProjectShareRenderer2 = _interopRequireDefault(_ProjectShareRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

var getProjectShareImage = function getProjectShareImage(_ref) {
  var project = _ref.project;
  var authorName = _ref.authorName;
  var projectTitle = _ref.projectTitle;
  var _ref$width = _ref.width;
  var width = _ref$width === undefined ? 1200 : _ref$width;
  var _ref$height = _ref.height;
  var height = _ref$height === undefined ? 630 : _ref$height;

  var $canvasContainer = document.createElement('div');

  return new _promise2.default(function (resolve) {
    (0, _reactDom.render)(_react2.default.createElement(_ProjectShareRenderer2.default, {
      project: project,
      authorName: authorName,
      projectTitle: projectTitle,
      width: width,
      height: height
    }), $canvasContainer, function () {
      var $canvas = $canvasContainer.querySelector('canvas');
      var imageData = $canvas.toDataURL('image/png');
      (0, _reactDom.unmountComponentAtNode)($canvasContainer);

      resolve(imageData);
    });
  });
};

exports.default = getProjectShareImage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectShareRenderer/getProjectShareImage.js
// module id = 591
// module chunks = 1